import { StopList } from "../../StopList";
import { StopProgress } from "../../StopProgress";
import { DataSource, Label, Layout, Panel, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutDispatchNext extends Layout {
    labelDriverCaption: Label;
    labelEta: Label;
    labelEtaCaption: Label;
    labelEtaDistance: Label;
    labelLateBadge: Label;
    labelLateStatus: Label;
    labelOrderId: Label;
    labelOrderIdCaption: Label;
    labelOrderWeight: Label;
    labelOrderWeightCaption: Label;
    layoutStopList: StopList;
    layoutStopProgress: StopProgress;
    panelCaseInfo: Panel;
    panelEquipment: Panel;
    panelEta: Panel;
    panelLateStatus: Panel;
    panelOrderWeight: Panel;
    panelOtherInfo: Panel;
    panelOverview: Panel;
    panelPrevDetails: Panel;
    panelTractorInfo: Panel;
    panelTrailer2: Panel;
    panelTrailer3: Panel;
    panelTrailerInfo: Panel;
    panelWeightInfo: Panel;
    sourceEquipmentGroup: DataSource;
    sourceMovement: DataSource;
    sourceStop: DataSource;
    textboxDriverId: Textbox;
    textboxDriverLoadUnload: Textbox;
    textboxPieces: Textbox;
    textboxTractorId: Textbox;
    textboxTrailer2: Textbox;
    textboxTrailer3: Textbox;
    textboxTrailerId: Textbox;
}
